export const ATTENDEE_ENTRY_TYPE = "attendee";
export const BUYER_ENTRY_TYPE = "buyer";

// Field Types
export const CHECKBOX_FIELD_TYPE = "checkbox";
export const SELECT_FIELD_TYPE = "select";
export const TEXTFIELD_FIELD_TYPE = "textfield";
export const TEXT_FIELD_TYPE = "text";
export const BOOLEAN_FIELD_TYPE = "boolean";
export const IMAGE_FIELD_TYPE = "Image";
export const BIRTHDATE_FIELD_TYPE = "birthdate";
export const DATE_FIELD_TYPE = "date";

// Valid Field Types for inference
export const VALID_FIELD_TYPES = new Set([
	CHECKBOX_FIELD_TYPE,
	DATE_FIELD_TYPE,
	SELECT_FIELD_TYPE,
	TEXT_FIELD_TYPE
]);

// Conditions
export const CONDITION_ISCHECKED = "ischecked";
export const CONDITION_ISEMPTY = "isempty";
export const CONDITION_EQUAL = "equal";
export const CONDITION_STARTSWITH = "startswith";
export const CONDITION_ISDIFFERENT = "isdifferent";
export const CONDITION_GT = "gt";
export const CONDITION_GTE = "gte";
export const CONDITION_LT = "lt";
export const CONDITION_LTE = "lte";
export const CONDITION_RANGE = "range";

export const CONDITION_TYPES = {
	[TEXTFIELD_FIELD_TYPE]: [
		CONDITION_EQUAL,
		CONDITION_STARTSWITH,
		CONDITION_ISDIFFERENT,
		CONDITION_GT,
		CONDITION_LT,
		CONDITION_ISEMPTY
	],
	[BOOLEAN_FIELD_TYPE]: [CONDITION_ISCHECKED],
	[IMAGE_FIELD_TYPE]: [CONDITION_ISEMPTY],
	[BIRTHDATE_FIELD_TYPE]: [CONDITION_RANGE, CONDITION_GTE, CONDITION_LTE],
	[CHECKBOX_FIELD_TYPE]: [CONDITION_EQUAL],
	[SELECT_FIELD_TYPE]: [CONDITION_EQUAL]
};

export const DEFAULT_CONDITIONS_BY_FIELD_TYPE = {
	[CHECKBOX_FIELD_TYPE]: CONDITION_ISCHECKED,
	[SELECT_FIELD_TYPE]: CONDITION_EQUAL
};

export const DATE_CONDITIONS = [CONDITION_GTE, CONDITION_LTE];

class FormEntry {
	constructor({
		pk,
		form_field_weez_id,
		form_field_name,
		form_field_type,
		form_field_choices
	}) {
		this.pk = pk;
		this.form_field_weez_id = form_field_weez_id || "";
		this.form_field_name = form_field_name || "";
		this.form_field_type = form_field_type || null;
		this.form_field_choices = form_field_choices || [];
	}

	static buildFromJSON(json) {
		return new FormEntry({
			pk: json.pk,
			form_field_weez_id: json.form_field_weez_id,
			form_field_name: json.form_field_name,
			form_field_type: json.form_field_type || null,
			form_field_choices: json.form_field_choices || []
		});
	}

	toJSON() {
		return {
			pk: this.pk,
			form_field_weez_id: this.form_field_weez_id,
			form_field_name: this.form_field_name,
			form_field_type: this.form_field_type,
			form_field_choices: this.form_field_choices
		};
	}

	getPk() {
		return this.pk;
	}

	getFormFieldWeezId() {
		return this.form_field_weez_id;
	}

	getFormFieldName() {
		return this.form_field_name;
	}

	getFormFieldType() {
		return this.form_field_type;
	}

	getFormFieldChoices() {
		return this.form_field_choices;
	}
}

class FormWithEntries {
	constructor({ form_pk, form_name, event_name, form_entries }) {
		this.form_pk = form_pk;
		this.form_name = form_name || "";
		this.event_name = event_name || "";
		this.form_entries = form_entries || [];
	}

	static buildFromJSON(json) {
		return new FormWithEntries({
			form_pk: json.form_pk,
			form_name: json.form_name,
			event_name: json.event_name,
			form_entries: json.form_entries
				? json.form_entries.map(entry => FormEntry.buildFromJSON(entry))
				: []
		});
	}

	toJSON() {
		return {
			form_pk: this.form_pk,
			form_name: this.form_name,
			event_name: this.event_name,
			form_entries: this.form_entries.map(entry => entry.toJSON())
		};
	}

	getFormPk() {
		return this.form_pk;
	}

	getFormName() {
		return this.form_name;
	}

	getEventName() {
		return this.event_name;
	}

	getFormEntries() {
		return this.form_entries;
	}
}

export default class FormsWithEntryUsage {
	constructor({ attendee_entries, buyer_entries }) {
		this.attendee_entries = attendee_entries || [];
		this.buyer_entries = buyer_entries || [];
	}

	static buildFromJSON(json) {
		return new FormsWithEntryUsage({
			attendee_entries: json.attendee_entries
				? json.attendee_entries.map(form =>
						FormWithEntries.buildFromJSON(form)
				  )
				: [],
			buyer_entries: json.buyer_entries
				? json.buyer_entries.map(form =>
						FormWithEntries.buildFromJSON(form)
				  )
				: []
		});
	}

	toJSON() {
		return {
			attendee_entries: this.attendee_entries.map(form => form.toJSON()),
			buyer_entries: this.buyer_entries.map(form => form.toJSON())
		};
	}

	getAttendeeEntries() {
		return this.attendee_entries;
	}

	getBuyerEntries() {
		return this.buyer_entries;
	}

	getAllForms() {
		return [...this.attendee_entries, ...this.buyer_entries];
	}
}
